<template>
  <div
    class="w-full bg-gray-800/5 rounded-[10px] p-3 tablet-h:px-[25px] tablet-h:pt-2 tablet-h:pb-[26px] mb-5"
  >
    <div
      class="font-medium text-center text-[14px] leading-[22px] tracking-[1px] text-gray-800/50 uppercase mb-3"
    >
      Your plan details
    </div>
    <div
      v-for="(price, index) in details.prices"
      :key="`price-${index}`"
      class="text-[14px] mb-1.5 w-full flex items-center justify-between leading-[22px] text-gray-800"
    >
      <div class="mr-3">{{ price.description }}</div>
      <div class="text-right">
        <template v-if="price.details.amount">
          {{ formatPriceLocal(price.details.amount / 100) }}
        </template>
        {{ price.details.suffix }}
      </div>
    </div>
  </div>

  <div class="mb-[26px]">
    <div class="flex items-center justify-between">
      <div class="text-[16px] font-medium text-gray-800">Details</div>
      <Pill>
        Due {{ convertToFriendlyDate(details.upcomingBilling?.date) }}
      </Pill>
    </div>
    <div class="text-[12px] text-gray-800/60">
      *Prorated charges for files you've added today
    </div>
  </div>

  <div class="text-[13px] leading-[14px] text-gray-500">
    <div class="flex items-center border-b border-[#E5E5E5] pb-2.5">
      <div class="grow">Item</div>
      <div class="w-[70px] text-right">Qty</div>
      <div class="w-[120px] text-right">Amount</div>
    </div>
    <div class="mt-2.5">
      <div
        v-for="item in details.upcomingBilling?.breakdown"
        :key="item.description.text"
        class="flex items-center mb-[14px] last:mb-0"
      >
        <div class="grow">{{ item.description.text }}</div>
        <div class="w-[70px] text-right">{{ item.quantity }}</div>
        <div class="w-[120px] text-right">
          {{ formatPriceLocal((item.amount || 0) / 100) }}
        </div>
      </div>
    </div>
    <div
      v-if="details.upcomingBilling?.tax"
      class="mt-2.5 border-t border-[#E5E5E5] pt-2.5 text-gray-500"
    >
      <div class="flex items-center">
        <div class="grow">Tax</div>
        <div class="w-[70px]"></div>
        <div class="w-[120px] text-right">
          {{ formatPriceLocal(details.upcomingBilling.tax / 100) }}
        </div>
      </div>
    </div>
    <div
      class="mt-2.5 border-t border-[#E5E5E5] pt-2.5 font-medium text-gray-800"
    >
      <div class="flex items-center">
        <div class="grow">Total</div>
        <div class="w-[70px]"></div>
        <div class="w-[120px] text-right">
          {{ formatPriceLocal((details.upcomingBilling?.total || 0) / 100) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Pill } from '@dacr/library'

import type { BillingPlanDetails } from '@/shared/graphql/legacy/generated'
import { formatTimestamp } from '@/shared/utils/datetime'
import { formatPrice } from '@/shared/utils/money'

const props = defineProps<{
  details: BillingPlanDetails
}>()

const convertToFriendlyDate = (date?: number) => {
  if (!date) return ''
  return formatTimestamp(date, {
    formatString: `LLLL d, yyyy`,
  })
}

const formatPriceLocal = (amount: number) => {
  return formatPrice({
    amount,
    currency: props.details.upcomingBilling?.currency,
  })
}
</script>
